import { Component, ChangeDetectionStrategy, inject, Inject } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { SidebarComponent } from './shared/components/sidebar/sidebar.component';
import { NavbarComponent } from './shared/components/navbar/navbar.component';
import { CommonModule, DOCUMENT } from '@angular/common';
import { NgxSpinnerModule } from 'ngx-spinner';
import { ToastModule } from 'primeng/toast';
import { NotificationService } from './shared/services/notification.service';
import { BaseComponent } from './shared/globalComponents/base/base.component';
import { takeUntil } from 'rxjs';
import { SidebarToggleService } from './shared/services/sidebar-toggle.service';
import { AuthService } from './core/auth/auth.service';
import { LoginFormComponent } from './core/auth/pages/login-form/login-form.component';
import { RegisterFormComponent } from './core/auth/pages/register-form/register-form.component';

@Component({
  selector: 'app-root',
  imports: [
    RouterOutlet,
    TranslateModule,
    CommonModule,
    ToastModule,
  ],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent extends BaseComponent {
  title = 'HRSystem';
  // private firebaseApp = inject(FirebaseApp);
  isSidebarCollapsed = false;

  constructor(
    private router: Router,
    private _NotificationService: NotificationService,
    private _SidebarToggleService: SidebarToggleService,
    private translate: TranslateService,
    private authService: AuthService,
    @Inject(DOCUMENT) private document: Document
  ) {
    super();
  }
  private messaging: any;

  ngOnInit(): void {
    // Handle auth token transfer across subdomains
    if (typeof window !== 'undefined' && window.location) {
      try {
        const urlParams = new URLSearchParams(window.location.search);
        const tokenFromUrl = urlParams.get('token');
        const userDataFromUrl = urlParams.get('user_data');
        if (tokenFromUrl) {
          let userObj: any = undefined;
          if (userDataFromUrl) {
            try {
              userObj = JSON.parse(decodeURIComponent(userDataFromUrl));
            } catch {}
          }
          this.authService.setAuthData(tokenFromUrl, undefined, userObj);

          // Clean URL parameters without reloading
          const cleanUrl = window.location.pathname;
          window.history.replaceState({}, document.title, cleanUrl);
        }
      } catch {}
    }

    this._SidebarToggleService.collapsed$
      .pipe(takeUntil(this.destroy$))
      .subscribe((value) => {
        this.isSidebarCollapsed = value;
        console.log(value);
      });

    // Initialize layout direction based on loaded language
    const currentLang = this.translate.currentLang || localStorage.getItem('lang') || 'en-US';
    this.updateDirection(currentLang);

    // Keep layout direction updated when language changes
    this.translate.onLangChange
      .pipe(takeUntil(this.destroy$))
      .subscribe((event) => {
        this.updateDirection(event.lang);
      });
  }

  private updateDirection(lang: string): void {
    const htmlTag = this.document.documentElement;
    htmlTag.dir = lang === 'ar' ? 'rtl' : 'ltr';
    htmlTag.lang = lang;
  }

  get isAuthRoute(): boolean {
    return this.router.url.includes('/auth');
  }
}
